import React, { useEffect, useMemo, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import { useFormState, useForm } from 'react-final-form';
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import { OnChange } from 'react-final-form-listeners';
import QCXAutocompleteSelect from '../../../../shared-components/autocomplete-select/QCXAutocompleteSelect' // lista suspensa
import MultiSelectFormInput from '../../../../ts/common/components/forms/MultiSelectFormInput';
import QCXFinalTextField from '../../../../shared-components/final-text-field/QCXFinalTextField';


export default function Lista({
    metadado, 
    isConsult,
    basePath="",
    ncm=false,
    ...restProps
}) {

    const [label, setLabel] = useState("")
    const [name,  setName] = useState("")
    const [nameCpfCnpj,  setNameCpfCnpj] = useState("")
    const [obrigatorio, setObrigatorio] = useState(false);
    const [codigo, setCodigo] = useState("");
    const [listValores, setListValores] = useState([]);
    const [defaultValue, setDefaultValue] = useState('');
    const [tamanhoMaximo, setTamanhoMaximo] = useState(null);

    const [tipoSelecionado, setTipoSelecionado] = useState(null);
    const [labelCampoCpfCnpj, setLabelCampoCpfCnpj] = useState('');

    const filterOptions = createFilterOptions({
        stringify: (item) => `${item.codigo} - ${item.value}`,
    });

    const labelCpfCnpj = {
      '1': 'CPF/CNPJ do adquirente:',
      '2': 'CPF/CNPJ do encomendante',
    }

    useEffect(() => {
      if (!ncm) {
        setName(`atributosAdicionais.lpcoForm.jsonFormulario.${metadado?.codigo}.valorComposto.indicacaoImportacaoTerceiros.codigoIndicador`)
        setNameCpfCnpj(`atributosAdicionais.lpcoForm.jsonFormulario.${metadado?.codigo}.valorComposto.indicacaoImportacaoTerceiros.cpfCnpj`)
      } else {
        setName(`atributosAdicionais.lpcoForm.jsonFormulario.ncm.dados.${metadado?.codigo}.valorComposto.indicacaoImportacaoTerceiros.codigoIndicador`)
        setNameCpfCnpj(`atributosAdicionais.lpcoForm.jsonFormulario.ncm.dados.${metadado?.codigo}.valorComposto.indicacaoImportacaoTerceiros.cpfCnpj`)
      }
      
      setLabel(metadado?.nome);
      setObrigatorio(metadado?.validacao?.obrigatorio || false);
   
      const dominio = [
        {
          id: '0',
          descricao: "Importação Direta",
        },
        {
          id: '1',
          descricao: "Importação por Conta e Ordem",
        },
        {
          id: '2',
          descricao: "Importação por Encomenda",
        },
      ]

      setListValores([...dominio].map(el => ({
          id: el.id,
          value: `${el.descricao}`,
      })))

      setDefaultValue({ id: null, value: '' });

    }, [metadado])

    if (!name) {
        return null;
    }

    return (
        <>
          <Grid item xs={12} sm={6} md={4}>
            <QCXAutocompleteSelect
                label={label}
                id={name}
                name={name}
                options={listValores}
                filterOptions={filterOptions}
                defaultValue={defaultValue}
                getOptionLabel={(item) => (
                    item.value ? item.value : ''
                )}
                required={obrigatorio}
                isConsult={isConsult}
                disabled={isConsult}
                {...restProps}
            />
            </Grid>

            {
              labelCampoCpfCnpj ? (
                <Grid item xs={12} sm={6} md={4}>
                  <QCXFinalTextField
                      id={codigo}
                      key={codigo}
                      name={nameCpfCnpj}
                      label={labelCampoCpfCnpj}
                      disabled={isConsult}
                      maxLength={tamanhoMaximo}
                      required={obrigatorio}
                      {...restProps}
                  />
                </Grid>
              ) : null
            }

            <OnChange name={name}>{(value, previous) => {
              setTipoSelecionado(value)
              setLabelCampoCpfCnpj(labelCpfCnpj[value] || '');
            }}</OnChange>
        </>
    )
    
    

}
